export default __webpack_public_path__ + "static/media/BALogoWhite.fec21711.png";